import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import { Authlayout } from "./layout/Authlayout";
import { PrivateLayout } from "./layout/PrivateLayout";
import Login from "./pages/authentication/Login";
import { Register } from "./pages/authentication/Register";
import { Brand } from "./pages/Brand/Brand";
import { Category } from "./pages/ProductCategory/ProductCategory";
import { Seller } from "./pages/Seller/Seller";

import "semantic-ui-css/semantic.min.css";
import { AddCuration } from "./pages/Curation/AddCuration";
import Curations from "./pages/Curation/Curations";
import { EditCuration } from "./pages/Curation/EditCuration";
import { Dashboard } from "./pages/Dashboard";
import { AddGrapeList } from "./pages/GrapeList/Add";
import { EditGrapeList } from "./pages/GrapeList/Edit";
import { GrapeList } from "./pages/GrapeList/GrapeList";
import { AddPersistentList } from "./pages/PersistentList/Add";
import { EditPersistentList } from "./pages/PersistentList/Edit";
import { PersistentList } from "./pages/PersistentList/PersistentList";
import { AddPlayoff } from "./pages/Playoff/Add";
import { EditPlayoff } from "./pages/Playoff/Edit";
import { Playoff } from "./pages/Playoff/Playoff";
import { PlayoffDetails } from "./pages/Playoff/PlayoffDetails";
import { Products } from "./pages/Product/Products";
import { Tags } from "./pages/Tags/Tags";
import { Test } from "./pages/test";
import { UserDetail } from "./pages/User/Details";
import { Users } from "./pages/User/User";
import { DarkTheme } from "./themes/darkTheme";

import { PrivateLayoutForRestrictedUser } from "./layout/PrivateLayoutForRestrictedUser";
import CurationViewTableDetails from "./pages/GraphDetailsScreen/CurationViewTableDetails";
import PlayoffViewTableDetails from "./pages/GraphDetailsScreen/PlayoffViewTableDetails";
import ProductViewTableDetails from "./pages/GraphDetailsScreen/ProductViewTableDetails";
import UserViewTableDetails from "./pages/GraphDetailsScreen/UserViewTableDetails";
import { CartProduct } from "./pages/UniverisalCart/pages/CartProduct";
import { Detail } from "./pages/UniverisalCart/pages/Orders/Detail";
import { List as OrderList } from "./pages/UniverisalCart/pages/Orders/List";
import { Add } from "./pages/UniverisalCart/pages/Playoff/Add";
import { Edit } from "./pages/UniverisalCart/pages/Playoff/Edit";
import { List } from "./pages/UniverisalCart/pages/Playoff/List";
import { Waitlist } from "./pages/Waitlist/Waitlist";
import ScraperLogs from "./pages/scraperLogs/pages/ScraperLogs";
import ProductLogs from "./pages/scraperLogs/pages/ProductLogs";
import { Ordering } from "./pages/Ordering/Ordering";
import AiOrders from "./pages/AiOrdersPage/AiOrders";
import ListingScreen from "./pages/Vouchers/ListingScreen";
import DetailScreen from "./pages/Vouchers/DetailScreen";
import VoucherListingScreen from "./pages/Vouchers/VoucherListingScreen";
import CreateOfferScreen from "./pages/Vouchers/CreateOfferScreen";
import CreateVoucherScreen from "./pages/Vouchers/CreateVoucherScreen";

import PlayoffView from "./pages/Playoff/PlayoffView";
import QueriesPage from "./pages/Search/Queries";
import AiSearchPage from "./pages/Search/AiSearch";
import ApiKeysPage from "./pages/Search/ApiKeys";
import VoucherDetailScreen from "./pages/Vouchers/VoucherDetailScreen";
import PlayoffBucketListing from "./pages/Playoff/PlayoffBucketListing"
import PopupCollections from "./pages/Popup/PopupCollections";
import { OutfitInsights } from "./pages/Insights/OutfitInsights";

function App() {
  // const theme = createTheme({
  // 	type: 'light',
  // 	typography: {
  // 		fontFamily: "'Poppins', sans-serif",
  // 	},
  // 	palette: {
  // 		primary: {
  // 			main: "#003B6D",
  // 			contrastText: "#fff",
  // 		},
  // 		secondary: pink,
  // 	},

  // });

  return (
    <ThemeProvider theme={DarkTheme}>
      <CssBaseline enableColorScheme />
      <BrowserRouter>
        <Routes>
          <Route path="/test" element={<Test />} />
          <Route path="/auth" element={<Authlayout />}>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route index element={<Navigate to="/auth/login" replace />} />
            {/* <Route
							path="*"
							element={<Navigate to="/auth/login" replace />}
						/> */}

            {/* <Redirect from="*" to="/auth/login" /> */}
            {/* <Route path="new" element={<NewBook />} /> */}
          </Route>
          <Route path="/w86zjruk6q" element={<PrivateLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="insights" element={<OutfitInsights />} />

            <Route path="seller" element={<Seller />} />
            <Route path="waitlist" element={<Waitlist />} />
            <Route path="brand" element={<Brand />} />
            <Route path="product-category" element={<Category />} />
            <Route path="listcategories" element={<Tags />} />
            <Route path="product" element={<Products />} />

            <Route path="grapelist" element={<GrapeList />} />
            <Route path="grapelist/add" element={<AddGrapeList />} />
            <Route path="grapelist/:id/edit" element={<EditGrapeList />} />

            <Route path="persistent-list" element={<PersistentList />} />
            <Route path="persistent-list/add" element={<AddPersistentList />} />
            <Route
              path="persistent-list/:id/edit"
              element={<EditPersistentList />}
            />

            <Route path="playoff" element={<Playoff />} />
            <Route path="details" element={<PlayoffDetails />} />
            <Route path="playoff/add" element={<AddPlayoff />} />
            <Route path="playoff/:id/edit" element={<EditPlayoff />} />
            <Route
              path="buckets"
              element={<PlayoffBucketListing />}
            />
            <Route path="popup/collections" element={<PopupCollections />} />
            <Route path="user" element={<Users />} />
            <Route path="user/:slug" element={<UserDetail />} />

            <Route path="curation" element={<Curations />} />
            <Route path="curation/add" element={<AddCuration />} />
            <Route path="curation/:id/edit" element={<EditCuration />} />

            <Route
              path="product-view-details"
              element={<ProductViewTableDetails />}
            />
            <Route
              path="user-graph-share-details"
              element={<UserViewTableDetails />}
            />
            <Route
              path="playoff-share-graph-details"
              element={<PlayoffViewTableDetails />}
            />
            <Route path="/w86zjruk6q/cart/products" element={<CartProduct />} />
            <Route path="/w86zjruk6q/cart/playoffs" element={<List />} />
            <Route path="/w86zjruk6q/cart/playoff/add" element={<Add />} />
            <Route path="/w86zjruk6q/ordering" element={<Ordering />} />

            <Route
              path="/w86zjruk6q/cart/playoff/:id/edit"
              element={<Edit />}
            />
            <Route path="/w86zjruk6q/cart/orders" element={<OrderList />} />
            <Route path="/w86zjruk6q/ai-orders" element={<AiOrders />} />
            <Route path="/w86zjruk6q/offers" element={<ListingScreen />} />
            <Route path="/w86zjruk6q/offers/:id" element={<DetailScreen />} />
            <Route
              path="/w86zjruk6q/offers/:id/vouchers"
              element={<VoucherListingScreen />}
            />
            <Route
              path="/w86zjruk6q/vouchers/:id"
              element={<VoucherDetailScreen />}
            />
            <Route
              path="/w86zjruk6q/offers/create"
              element={<CreateOfferScreen />}
            />
            <Route
              path="/w86zjruk6q/offers/:id/edit"
              element={<CreateOfferScreen />}
            />
            <Route
              path="/w86zjruk6q/cart/orders/:id/detail"
              element={<Detail />}
            />
            <Route
              path="curation-share-details"
              element={<CurationViewTableDetails />}
            />

            <Route path="cart/products" element={<CartProduct />} />
            <Route path="cart/playoffs" element={<List />} />
            <Route path="cart/playoff/add" element={<Add />} />
            <Route path="cart/playoff/:id/edit" element={<Edit />} />
            <Route path="cart/playoff/:id" element={<PlayoffView />} />

            <Route path="cart/orders" element={<OrderList />} />
            <Route path="cart/orders/:id/detail" element={<Detail />} />

            <Route path="search/queries" element={<QueriesPage />} />
            <Route path="search/ai" element={<AiSearchPage />} />
            <Route path="search/api-keys" element={<ApiKeysPage />} />
            <Route path="ordering" element={<Ordering />} />

            <Route path="ai-orders" element={<AiOrders />} />

            <Route path="offers" element={<ListingScreen />} />
            <Route path="offers/:id" element={<DetailScreen />} />
            <Route
              path="offers/:id/vouchers"
              element={<VoucherListingScreen />}
            />
            <Route path="vouchers/create" element={<CreateVoucherScreen />} />
            <Route
              path="/w86zjruk6q/vouchers/:id/edit"
              element={<CreateVoucherScreen />}
            />
            <Route path="vouchers" element={<VoucherListingScreen />} />

            <Route path="product_logs" element={<ProductLogs />} />
            <Route path="scraper_logs" element={<ScraperLogs />} />
          </Route>

          <Route
            path="/upload-playoff"
            element={<PrivateLayoutForRestrictedUser />}
          >
            <Route index element={<Playoff />}></Route>
            <Route path="/upload-playoff/product" element={<Products />} />
            <Route path="brand" element={<Brand />} />

            <Route path="/upload-playoff/playoff" element={<Playoff />} />
            <Route path="grapelist" element={<GrapeList />} />
            <Route path="grapelist/add" element={<AddGrapeList />} />
            <Route path="grapelist/:id/edit" element={<EditGrapeList />} />

            <Route path="persistent-list" element={<PersistentList />} />
            <Route path="persistent-list/add" element={<AddPersistentList />} />
            <Route
              path="persistent-list/:id/edit"
              element={<EditPersistentList />}
            />
            {/* <Route
							path="/upload-playoff/details"
							element={<PlayoffDetails />}
						/> */}
            <Route
              path="/upload-playoff/playoff/add"
              element={<AddPlayoff />}
            />
            <Route
              path="/upload-playoff/playoff/:id/edit"
              element={<EditPlayoff />}
            />
            <Route
              path="/upload-playoff/cart/products"
              element={<CartProduct />}
            />
            <Route path="/upload-playoff/cart/playoffs" element={<List />} />

            <Route path="/upload-playoff/cart/playoff/add" element={<Add />} />
            <Route
              path="/upload-playoff/cart/playoff/:id/edit"
              element={<Edit />}
            />
          </Route>
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
